import { lazy, Suspense } from "react";
import { ThemeProvider } from "@hooks/useTheme";
import { ModalProvider } from "@hooks/useModal";
import { HeaderProvider } from "@hooks/useHeader";
import { Toaster } from "react-hot-toast";
import CustomLoader from "@components/loader.page";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { constants } from "@lib/constants";

// const AntdThemeWrapper = lazy(() => import("./wrapper.antd"));
import AntdThemeWrapper from "./wrapper.antd";

export default function AppProviders({ children }) {
  return (
    <Suspense fallback={<CustomLoader />}>
      <GoogleOAuthProvider clientId={constants.GOOGLE_CLIENT_ID}>
        <ThemeProvider>
          <AntdThemeWrapper>
            <ModalProvider>
              <HeaderProvider>
                {children}
              </HeaderProvider>
            </ModalProvider>
            <Toaster
              position="top-center"
              toastOptions={{
                success: { className: "react-hot-toast-success" },
                error: { className: "react-hot-toast-error" },
                loading: { className: "react-hot-toast-loading" },
              }}
            />
          </AntdThemeWrapper>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </Suspense>
  );
}